<template>
  <div class="mb-24">
    <div
      class="text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden"
    >
      <div class="bg-theme-green px-4 py-2 text-white">
        <div class="flex justify-between items-center">
          <div class="font-bold tracking-wider leading-tight text-2xl mt-0">
            {{item.name}}
          </div>
          <div class="flex flex-col items-center">
            <div
              @click.prevent="clearComponent()"
              class="self-end cursor-pointer rounded-md text-white py-2 pl-2 hover:opacity-70"
              >CLOSE</div>
            <div class="flex justify-end gap-2 flex-row">
              <button
                @click.prevent="update()"
                class="h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase"
              >
                SAVE
              </button>

              <div class="mb-1 relative flex justify-end gap-2" tabindex="1" @focusout="focusOutDropDown">
                <div @click="toggleDropDown" class="cursor-pointer uppercase hover:bg-slate-100 px-[14px] py-[10px] bg-white rounded text-sm tracking-widest text-theme-green">...</div>
                <div v-if="editDropDown" class="absolute top-14 right-0 mt-1 w-[220px] z-10 rounded-md shadow-lg">
                    <div class="absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                    <ul role="listbox" class="bg-gray-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                        <li @click="removeBanner(item.id)" class="cursor-pointer text-white last:text-theme-red hover:bg-light-black select-none relative py-2 pl-3 pr-9">
                            <div class="flex items-center">
                                <span class="ml-3 block font-normal uppercase">
                                    Delete
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
        <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">
          <div class="w-full xl:w-1/3">
            <div class="flex xl:flex-row flex-col gap-3 items-start">
              <div class="w-full">
                <div :class="'input-wrapper ' + form.name.error_type">
                  <label class="text-xs mb-1">Name:</label>
                  <input
                    placeholder="Main Banner"
                    @keyup="validateFields(['name'])"
                    v-model="form.name.value"
                    class="block rounded bg-gray-black w-full"
                    type="text"
                  />
                  <p
                    class="field-error label-text mt-1"
                    v-if="form.name.error_message"
                    v-text="form.name.error_message"
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full xl:w-1/3">
            <div class="flex xl:flex-row flex-col gap-3 items-start">
              <div class="w-full">
                <div :class="'input-wrapper '">
                  <label class="text-xs mb-1">Locations:</label>
                  <select-checkbox mode="tags" class="bg-gray-black rounded border border-gray-500" placeholder="Select Any" v-model="form.location" :options="options">
                        <template v-slot:placeholderIcon >
                            <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.75 18.025C10.9667 16.0083 12.6042 14.1792 13.6625 12.5375C14.7208 10.8958 15.25 9.45 15.25 8.2C15.25 6.23333 14.6208 4.625 13.3625 3.375C12.1042 2.125 10.5667 1.5 8.75 1.5C6.93333 1.5 5.39583 2.125 4.1375 3.375C2.87917 4.625 2.25 6.23333 2.25 8.2C2.25 9.45 2.79167 10.8958 3.875 12.5375C4.95833 14.1792 6.58333 16.0083 8.75 18.025ZM8.75 20C6.06667 17.7167 4.0625 15.5958 2.7375 13.6375C1.4125 11.6792 0.75 9.86667 0.75 8.2C0.75 5.7 1.55417 3.70833 3.1625 2.225C4.77083 0.741667 6.63333 0 8.75 0C10.8667 0 12.7292 0.741667 14.3375 2.225C15.9458 3.70833 16.75 5.7 16.75 8.2C16.75 9.86667 16.0875 11.6792 14.7625 13.6375C13.4375 15.5958 11.4333 17.7167 8.75 20Z" fill="white"/>
                            </svg>
                        </template>
                    </select-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full xl:w-1/3 flex justify-start">
            <div class="input-wrapper">
              <span class="mb-0 text-xs">Category Type</span>
              <div class="flex mt-1">
                <span
                  @click="form.featured = false"
                  :class="
                    'cursor-pointer mr-2 text-sm font-medium ' +
                    (form.featured ? 'text-theme-878686' : 'text-white')
                  "
                >
                  Main
                </span>
                <label class="flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    v-model="form.featured"
                    class="hidden peer"
                  />
                  <div
                    :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full bg-theme-green border-theme-green'"
                  ></div>
                </label>
                <span
                  @click="form.featured = true"
                  :class="
                    'cursor-pointer ml-2 text-sm font-medium ' +
                    (form.featured ? 'text-white' : 'text-theme-878686')
                  "
                >
                  Featured
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex xl:flex-row flex-col gap-3 items-start mb-3">
          <div class="w-full xl:w-1/3">
            <div class="flex xl:flex-row flex-col gap-3 items-start">
              <div class="w-full">
                <div :class="'input-wrapper ' + form.ctaValue.error_type">
                  <label class="text-xs mb-1">Hyperlink:</label>
                  <input
                    placeholder="Main Banner"
                    @keyup="validateFields(['ctaValue'])"
                    v-model="form.ctaValue.value"
                    class="block rounded bg-gray-black w-full"
                    type="text"
                  />
                  <p
                    class="field-error label-text mt-1"
                    v-if="form.ctaValue.error_message"
                    v-text="form.ctaValue.error_message"
                  ></p>
                </div>
              </div>
            </div>
          </div>

          <div class="xl:w-1/3 w-full">
            <div :class="'input-wrapper ' + form.startDate.error_type">
              <label class="text-xs mb-1">Start Date</label>
              <div class="block d-picker bg-gray-black rounded w-full flex items-center">
                <span class="ml-2 mr-2">
                  <svg
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z"
                      fill="white"
                    />
                  </svg>
                </span>
                 <Datepicker :inputFormat="'yyyy-MM-dd'" :lowerLimit="new Date()" placeholder="Select a Date" v-model="form.startDate.value" class="focus:border-transparent rounded h-[42px] focus:ring-0 bg-gray-black border-0 w-full"/>
              </div>
              <p
                class="field-error label-text mt-1"
                v-if="form.startDate.error_message"
                v-text="form.startDate.error_message"
              ></p>
            </div>
          </div>

          <div class="xl:w-1/3 w-full">
            <div :class="'input-wrapper ' + form.endDate.error_type">
              <label class="text-xs mb-1">End Date</label>
              <div class="block d-picker bg-gray-black rounded w-full flex items-center">
                <span class="ml-2 mr-2">
                  <svg
                    width="18"
                    height="20"
                    viewBox="0 0 18 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM9 16C8.71667 16 8.47917 15.9042 8.2875 15.7125C8.09583 15.5208 8 15.2833 8 15C8 14.7167 8.09583 14.4792 8.2875 14.2875C8.47917 14.0958 8.71667 14 9 14C9.28333 14 9.52083 14.0958 9.7125 14.2875C9.90417 14.4792 10 14.7167 10 15C10 15.2833 9.90417 15.5208 9.7125 15.7125C9.52083 15.9042 9.28333 16 9 16ZM5 16C4.71667 16 4.47917 15.9042 4.2875 15.7125C4.09583 15.5208 4 15.2833 4 15C4 14.7167 4.09583 14.4792 4.2875 14.2875C4.47917 14.0958 4.71667 14 5 14C5.28333 14 5.52083 14.0958 5.7125 14.2875C5.90417 14.4792 6 14.7167 6 15C6 15.2833 5.90417 15.5208 5.7125 15.7125C5.52083 15.9042 5.28333 16 5 16ZM13 16C12.7167 16 12.4792 15.9042 12.2875 15.7125C12.0958 15.5208 12 15.2833 12 15C12 14.7167 12.0958 14.4792 12.2875 14.2875C12.4792 14.0958 12.7167 14 13 14C13.2833 14 13.5208 14.0958 13.7125 14.2875C13.9042 14.4792 14 14.7167 14 15C14 15.2833 13.9042 15.5208 13.7125 15.7125C13.5208 15.9042 13.2833 16 13 16ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0H4.75V1.5H13.25V0H14.875V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5ZM1.5 6.25H16.5V3H1.5V6.25ZM1.5 6.25V3V6.25Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <Datepicker :inputFormat="'yyyy-MM-dd'" :lowerLimit="endDateLimit" placeholder="Select a Date" v-model="form.endDate.value" class="focus:border-transparent rounded h-[42px] focus:ring-0 bg-gray-black border-0 w-full w-[130px] overflow-hidden"/>
              </div>
              <p
                class="field-error label-text mt-1"
                v-if="form.endDate.error_message"
                v-text="form.endDate.error_message"
              ></p>
            </div>
          </div>
        </div>

        <div :class="'input-wrapper ' + form.image.error_type">
            <label class="text-xs mb-1">Hyperlink:</label>
            <DragDrop
            @change="validateFields(['image'])"
            v-model="form.image.value"
            />
            <p
            class="field-error label-text mt-1"
            v-if="form.image.error_message"
            v-text="form.image.error_message"
            ></p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { defineComponent, ref } from 'vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PromotionApis from '@/controllers/PromotionApis'
import { useSnackbar } from 'vue3-snackbar'
import Datepicker from 'vue3-datepicker'
import Helpers from '@/helpers'
import SelectCheckbox from '@/components/form/SelectCheckbox.vue'
import DragDrop from './DragDrop.vue'
import moment from 'moment'

export default defineComponent({
  components: {
    Datepicker,
    SelectCheckbox,
    DragDrop
  },
  props: {
    clearComponent: {
      type: Function,
      required: true
    },
    item: {
        type: Object,
        required: true
    }
  },
  setup() {
    const snackbar = useSnackbar()
    const editDropDown = ref(false)
    const form = ref({
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required']
      },
      location: [],
      featured: false,
      ctaValue: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['url']
      },
     startDate: {
          value: null,
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        endDate: {
          value: null,
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
     
      image: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required']
      }
    })
    return {
      form,
      editDropDown,
      snackbar,
    }
  },

  async mounted(){
    this.loadData()
    this.getLocations()
  },

  watch: {
    'form.startDate.value'(val) {

        this.validateFields(['startDate']);
        if(this.form.endDate.value != null || this.form.endDate.value != 'Invalid date') {
          // then need to check
          let endDate = moment(this.form.endDate.value);
          let startDate = moment(this.form.startDate.value);
          let dayGap = endDate.diff(startDate, 'day');
          if(dayGap < 0) {
            this.snackbar.add({
              type: 'info',
              text: 'End date must be equal or greater than start date.',
              duration: 3000,
            })
            this.form.endDate.value = null;
          }
          
        }
      },
      'form.endDate.value'() {
        this.validateFields(['endDate']);
        let endDate = moment(this.form.endDate.value);
        let startDate = moment(this.form.startDate.value);
        let dayGap = endDate.diff(startDate, 'day');
        if(dayGap < 0) {
          this.snackbar.add({
            type: 'info',
            text: 'End date must be equal or greater than start date.',
            duration: 3000,
          })
          this.form.endDate.value = null;
        }
      },
    async item(){
      this.loadData()
      this.getLocations()
    }
  },

  computed: {
    endDateLimit() {
        return this.form.startDate ?  moment(this.form.startDate).toDate() : new Date();
      },
    options() {
        return this.vg_location.map(each => ({id:each.id, name:each.name}))
    },
    ...mapGetters({
        vg_location: 'location/list',
    })
  },

  methods: {
    loadData(){
      this.form.name.value = this.item.name
      this.form.featured = this.item.featured
      // this.form.location = this.item
      this.form.ctaValue.value = this.item.ctaValue
      this.form.startDate.value = this.item.startDate?moment(this.item.startDate).toDate():null
      this.form.endDate.value = this.item.endDate?moment(this.item.endDate).toDate():null
      this.form.image.value = this.item.image
    },
    async getLocations(){
      let {data} = await PromotionApis.getPromotionLocation(this.item.id)
      if(data.payload){
        this.form.location = data.payload.map(each => each.id)
      }
    },
    toggleDropDown(){
        this.editDropDown = !this.editDropDown
    },
    focusOutDropDown(){
      this.editDropDown = false
    },
    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields)
      // capture the fields
      this.form = res.data
      return res.error ? false : true
    },

    updateImage(val){
        this.form.image = val
    },

    /**
     * Add new location Tax
     */
    async update() {
        let validate = await this.validateFields(['name', 'startDate', 'endDate', 'image']);
        if(!validate) {
          return ;
        }
        let data = Helpers.getFormKeyValue(this.form);
        data.startDate = moment(data.startDate).format('YYYY-MM-DD')
        data.endDate = moment(data.endDate).format('YYYY-MM-DD')
        data.description = data.name
        data.ctaType = 'hyperlink'
        data.ctaText = data.ctaValue
        data.status = this.item.status

        this.va_spinner(true);
        let res = await PromotionApis.updatePromotion(this.item.id, data);
        if(res.status==200){
          await PromotionApis.assignLocationToPromotion(this.item.id, {locationIds: this.form.location})
        }
        this.va_spinner(false);
          this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        if(res.status == 200 ) {
          this.emitter.emit('reloadBanner', true)
        }
    },
    async removeBanner(id){
      this.confirm("Are you sure to delete this banner?").then(async () => {
        this.va_spinner(true);
        let res = await PromotionApis.removePromotion(id)
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        this.va_spinner(false);
        this.emitter.emit('reloadBanner', true)
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner'
    })
  }
})
</script>